import type { Schema } from "./api";
import { jobStatusText } from "./jobs";
import { targetedDelivery } from "./targetedDelivery";

type Finding = { description: string; correction: string; category: string | null; action: string };
type Report = { round?: number; phase?: string; findings?: { message: string }[];
  audit?: { summary: string; findings: Finding[] };
  history?: { round: number; audit: { summary: string; findings: Finding[] }; checks: { message: string }[] }[] };

export function FinalReviewReport({ job, canEdit, resume, cancel }: {
  job: Schema["JobOut"]; canEdit: boolean; resume: () => void; cancel: () => void;
}) {
  const report = (job.details.final_review ?? {}) as Report;
  const delivery = targetedDelivery(job);
  return <details className="analysis-coverage" open={job.status === "paused" || job.status === "failed"}>
    <summary>{delivery ? "Комплект подготовлен для профессиональной проверки" : <>Полная проверка комплекта · {jobStatusText(job)}</>}</summary>
    {delivery ? <>
      <p>Адресные исправления: {delivery.corrected} из 18. Скачано и технически проверено файлов: {delivery.files}.</p>
      <p><a className="primary button-link" href={delivery.href} download>Скачать готовый комплект (ZIP)</a></p>
      <p>В архиве — Word, Excel, PDF, оба аудита и журнал исправлений. Нерешённых вопросов: {delivery.questions}.</p>
      {delivery.supplements && <p>{delivery.supplements.map(file=><a className="quiet button-link" key={file.href} href={file.href} download>{file.label}</a>)}</p>}
      <p>После последних исправлений полного независимого аудита не было. Профессиональное согласование требуется отдельно.</p>
      <p className="muted">Исходные заключения и история ниже сохранены. Результаты исправлений и оставшиеся вопросы включены в архив.</p>
    </> : <>
      <p>{job.message}</p>
      {report.round !== undefined && <p>Круг проверки: {report.round + 1}. После исправлений заново сверяется весь комплект.</p>}
      <p>Проверка не подтверждает работы за специалиста. Приёмка выгруженных файлов выполняется отдельно.</p>
    </>}
    {report.audit?.summary && <p>{report.audit.summary}</p>}
    {!!report.findings?.length && <details><summary>Проверки данных: {report.findings.length}</summary>
      <ul>{report.findings.map((finding, index) => <li key={index}>{finding.message}</li>)}</ul>
    </details>}
    {report.audit?.findings.map((finding, index) => <section key={index}>
      <h3>{finding.category || "Весь комплект"} · {finding.action === "repair" ? "Исправление" : "Требует уточнения"}</h3>
      <p>{finding.description}</p><p>{finding.correction}</p>
    </section>)}
    {!!report.history?.length && <details><summary>История кругов</summary>
      {report.history.map(round => <p key={round.round}>Круг {round.round + 1}: {round.audit.summary} Замечаний: {round.audit.findings.length}; проверок с замечаниями: {round.checks.length}.</p>)}
    </details>}
    {!delivery && canEdit && ["paused", "failed", "cancelled"].includes(job.status) && <button onClick={resume}>Продолжить проверку</button>}
    {canEdit && ["waiting", "queued", "running"].includes(job.status) && !job.cancel_requested && <button className="quiet" onClick={cancel}>Остановить проверку</button>}
  </details>;
}
